module.exports = __webpack_public_path__ + "fonts/circular-bold.fc61ae0.woff";